/* Peregrine Gear Co. — Vanilla JS */
(function() {
  'use strict';

  // ===== UTILITIES =====
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  // ===== ANNOUNCEMENT BAR =====
  function initAnnouncementBar() {
    const bar = $('.announcement-bar');
    const closeBtn = $('.announcement-bar__close');
    if (!bar || !closeBtn) return;
    if (sessionStorage.getItem('pgc-bar-dismissed')) bar.classList.add('hidden');
    closeBtn.addEventListener('click', () => {
      bar.classList.add('hidden');
      sessionStorage.setItem('pgc-bar-dismissed', '1');
    });
  }

  // ===== HEADER SCROLL =====
  function initHeaderScroll() {
    const header = $('.site-header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ===== MOBILE MENU =====
  function initMobileMenu() {
    const openBtn = $('.mobile-menu-btn');
    const closeBtn = $('.mobile-menu__close');
    const menu = $('.mobile-menu');
    const overlay = $('.menu-overlay');
    if (!openBtn || !menu) return;

    const open = () => {
      menu.classList.add('open');
      overlay && overlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      menu.classList.remove('open');
      overlay && overlay.classList.remove('visible');
      document.body.style.overflow = '';
    };
    openBtn.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
  }

  // ===== SEARCH =====
  function initSearch() {
    const openBtn = $('.search-open-btn');
    const modal = $('.search-modal');
    const input = modal && $('.search-input', modal);
    if (!openBtn || !modal) return;
    const open = () => { modal.classList.add('open'); input && input.focus(); document.body.style.overflow = 'hidden'; };
    const close = () => { modal.classList.remove('open'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', open);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
  }

  // ===== CART DRAWER =====
  const Cart = {
    drawer: null,
    overlay: null,
    itemsEl: null,
    subtotalEl: null,
    shippingFill: null,
    shippingText: null,
    countBadges: null,
    freeShippingThreshold: 5000, // pence — £50

    init() {
      this.drawer = $('.cart-drawer');
      this.overlay = $('.cart-overlay');
      this.itemsEl = $('.cart-drawer__items');
      this.subtotalEl = $('.cart-drawer__subtotal-amount');
      this.shippingFill = $('.shipping-bar-fill');
      this.shippingText = $('.shipping-bar-text');
      this.countBadges = $$('.cart-count-badge');
      if (!this.drawer) return;

      const closeBtn = $('.cart-drawer__close');
      closeBtn && closeBtn.addEventListener('click', () => this.close());
      this.overlay && this.overlay.addEventListener('click', () => this.close());

      $$('.open-cart-btn').forEach(btn => btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      }));

      document.addEventListener('cart:updated', () => this.refresh());
      this.refresh();
    },

    open() {
      this.drawer.classList.add('open');
      this.overlay && this.overlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer.classList.remove('open');
      this.overlay && this.overlay.classList.remove('visible');
      document.body.style.overflow = '';
    },

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
      } catch (e) {}
    },

    updateCount(count) {
      this.countBadges.forEach(badge => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    },

    updateShippingBar(total) {
      if (!this.shippingFill || !this.shippingText) return;
      const remaining = this.freeShippingThreshold - total;
      const pct = Math.min(100, (total / this.freeShippingThreshold) * 100);
      this.shippingFill.style.width = pct + '%';
      if (remaining <= 0) {
        this.shippingText.innerHTML = '<strong>You\'ve unlocked free UK delivery!</strong> 🎉';
      } else {
        const amount = (remaining / 100).toFixed(2);
        this.shippingText.innerHTML = `Spend <strong>£${amount} more</strong> for free UK delivery`;
      }
    },

    render(cart) {
      this.updateCount(cart.item_count);
      this.updateShippingBar(cart.total_price);

      if (!this.itemsEl) return;

      if (cart.item_count === 0) {
        this.itemsEl.innerHTML = `
          <div class="cart-drawer__empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            <p>Your cart is empty.</p>
            <a href="/collections/all" class="btn btn-primary">Shop now</a>
          </div>`;
        if (this.subtotalEl) this.subtotalEl.textContent = '£0.00';
        return;
      }

      this.itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}" loading="lazy">
          <div class="cart-item__info">
            <div class="cart-item__title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            <div class="cart-item__row">
              <div class="cart-item__qty">
                <button class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
                <span>${item.quantity}</span>
                <button class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>
              <div class="cart-item__price">£${(item.final_line_price / 100).toFixed(2)}</div>
            </div>
            <button class="cart-item__remove" data-key="${item.key}">Remove</button>
          </div>
        </div>`).join('');

      if (this.subtotalEl) {
        this.subtotalEl.textContent = `£${(cart.total_price / 100).toFixed(2)}`;
      }

      $$('.cart-qty-btn', this.itemsEl).forEach(btn => {
        btn.addEventListener('click', async () => {
          await this.updateItem(btn.dataset.key, parseInt(btn.dataset.qty));
        });
      });
      $$('.cart-item__remove', this.itemsEl).forEach(btn => {
        btn.addEventListener('click', async () => {
          await this.updateItem(btn.dataset.key, 0);
        });
      });
    },

    async updateItem(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        this.render(cart);
      } catch(e) {}
    },

    async addItem(variantId, qty = 1) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        await res.json();
        await this.refresh();
        this.open();
      } catch(e) {
        console.error('Add to cart failed:', e);
      }
    }
  };

  // ===== ADD TO CART =====
  function initAddToCart() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-atc]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId || btn.dataset.atc;
      if (!variantId) return;
      const qtyInput = document.querySelector('.qty-input');
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      btn.disabled = true;
      const orig = btn.textContent;
      btn.textContent = 'Adding…';
      await Cart.addItem(variantId, qty);
      btn.textContent = 'Added!';
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
    });
  }

  // ===== PRODUCT GALLERY =====
  function initProductGallery() {
    const gallery = $('.product-gallery');
    if (!gallery) return;
    const main = $('.product-gallery__main', gallery);
    const mainImg = main && $('img', main);
    const thumbs = $$('.product-gallery__thumb', gallery);

    // Thumb switching
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.src = thumb.querySelector('img').src.replace('_100x100', '_800x800').replace('_72x72', '_800x800');
        }
      });
    });
    if (thumbs.length) thumbs[0].classList.add('active');

    // Zoom on desktop
    if (main) {
      main.addEventListener('click', () => {
        main.classList.toggle('zoomed');
      });
      main.addEventListener('mousemove', (e) => {
        if (!main.classList.contains('zoomed')) return;
        const r = main.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
        const y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
        main.style.setProperty('--zoom-x', x + '%');
        main.style.setProperty('--zoom-y', y + '%');
      });
    }
  }

  // ===== VARIANT SELECTORS =====
  function initVariantSelectors() {
    const pills = $$('.option-pill');
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const group = pill.closest('.product-option-pills');
        $$('.option-pill', group).forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      const selected = {};
      $$('.product-options .product-option').forEach(opt => {
        const name = opt.dataset.optionName;
        const activePill = $('.option-pill.selected', opt);
        if (activePill) selected[name] = activePill.dataset.value;
      });

      const variantsData = window.productVariants;
      if (!variantsData) return;
      const match = variantsData.find(v =>
        Object.entries(selected).every(([k, val]) => v.options[k] === val)
      );
      if (match) {
        $$('[data-atc]').forEach(btn => btn.dataset.variantId = match.id);
        $$('[data-atc]').forEach(btn => {
          btn.dataset.atc = match.id;
          if (!match.available) {
            btn.disabled = true;
            btn.textContent = 'Sold out';
          } else {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          }
        });
        const priceEl = $('.product-details__price');
        if (priceEl && match.price) {
          priceEl.textContent = `£${(match.price / 100).toFixed(2)}`;
        }
      }
    }
    // Set first pill selected
    $$('.product-option-pills').forEach(g => {
      const first = $('[data-value]', g);
      if (first) first.classList.add('selected');
    });
  }

  // ===== QUANTITY SELECTOR =====
  function initQuantity() {
    const input = $('.qty-input');
    if (!input) return;
    $('.qty-btn[data-action="minus"]') && $('.qty-btn[data-action="minus"]').addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    $('.qty-btn[data-action="plus"]') && $('.qty-btn[data-action="plus"]').addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  }

  // ===== STICKY MOBILE ATC =====
  function initStickyAtc() {
    const atc = $('.product-actions');
    const sticky = $('.sticky-atc');
    if (!atc || !sticky) return;
    const obs = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('visible', !entry.isIntersecting);
    }, { rootMargin: '0px' });
    obs.observe(atc);

    const stickyBtn = $('.sticky-atc button[data-atc]');
    const mainBtn = $('[data-atc].btn-primary');
    if (stickyBtn && mainBtn) {
      stickyBtn.dataset.atc = mainBtn.dataset.atc;
      stickyBtn.dataset.variantId = mainBtn.dataset.variantId;
    }
  }

  // ===== ACCORDION =====
  function initAccordions() {
    $$('.accordion-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion-item');
        const isOpen = item.classList.contains('open');
        $$('.accordion-item').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  // ===== RECENTLY VIEWED =====
  const RecentlyViewed = {
    KEY: 'pgc-rv',
    MAX: 4,

    get() {
      try { return JSON.parse(localStorage.getItem(this.KEY)) || []; } catch(e) { return []; }
    },

    add(product) {
      const items = this.get().filter(p => p.id !== product.id);
      items.unshift(product);
      localStorage.setItem(this.KEY, JSON.stringify(items.slice(0, this.MAX)));
    },

    render(container) {
      if (!container) return;
      const items = this.get();
      if (items.length === 0) { container.closest('section') && (container.closest('section').style.display = 'none'); return; }
      container.innerHTML = items.map(p => `
        <div class="product-card">
          <a href="${p.url}">
            <div class="product-card__media">
              <img class="product-card__img" src="${p.image}" alt="${p.title}" loading="lazy">
            </div>
          </a>
          <div class="product-card__info">
            <a href="${p.url}"><div class="product-card__name">${p.title}</div></a>
            <div class="product-card__price">£${p.price}</div>
          </div>
        </div>`).join('');
    }
  };

  function initRecentlyViewed() {
    if (window.currentProduct) RecentlyViewed.add(window.currentProduct);
    RecentlyViewed.render($('.recently-viewed-grid'));
  }

  // ===== COLLECTION SORT =====
  function initCollectionSort() {
    const sortSelect = $('.collection-sort select');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ===== NEWSLETTER =====
  function initNewsletter() {
    $$('.footer-newsletter').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('input[type="email"]');
        const btn = form.querySelector('button');
        if (!input || !input.value) return;
        btn.textContent = 'Done!';
        btn.disabled = true;
        setTimeout(() => { btn.textContent = 'Sign up'; btn.disabled = false; input.value = ''; }, 3000);
      });
    });
  }

  // ===== CONTACT FORM =====
  function initContactForm() {
    const form = $('.contact-form');
    if (!form) return;
    // Shopify handles this natively via action="/contact"
  }

  // ===== INIT =====
  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementBar();
    initHeaderScroll();
    initMobileMenu();
    initSearch();
    Cart.init();
    initAddToCart();
    initProductGallery();
    initVariantSelectors();
    initQuantity();
    initStickyAtc();
    initAccordions();
    initRecentlyViewed();
    initCollectionSort();
    initNewsletter();
    initContactForm();
  });

})();
